import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component } from '@angular/core';
import { Router } from "@angular/router";
import { NgForm } from '@angular/forms';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent {
  invalidLogin: boolean;

  constructor(
    private router: Router,
    private http: HttpClient,
    private _authService: AuthService) { }

  login(form: NgForm) {
    let credentials = JSON.stringify(form.value);

    //this.http.post("http://localhost:51057/api/auth/login", credentials, {
    //  headers: new HttpHeaders({
    //    "Content-Type": "application/json; charset=utf-8"
    //  })
    //}).subscribe(response => {
    //  let token = (<any>response).token;
    //  localStorage.setItem("jwt", token);
    //  this.invalidLogin = false;
    //  this.router.navigate(["home"]);
    //}, err => {
    //  this.invalidLogin = true;
    //});

    this._authService.getAuth(credentials)
      .subscribe(response => {
        let token = (<any>response).token;
        localStorage.setItem("jwt", token);
        this.invalidLogin = false;
        this.router.navigate(["home"]);
      }, err => {
        this.invalidLogin = true;
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts